<template>
    <div>
        <div class="row" v-for="(bag, n) in genreArticles" :key="'article-row-' + n">
            <div class="col-md-4 mb-2" v-for="a in bag" :key="'article-' + a.id">
                <article-card
                    :article="a"></article-card>
            </div>
        </div>
        <div class="load-more d-flex justify-content-center align-content-center flex-wrap h-100"
            v-if="hasMorePage" @click="loadArticle()">
            <div>
                もっと記事を読み込む...
                <i class="fas fa-chevron-down"></i>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="false"></loading>
    </div>
</template>

<style scoped lang="scss">
.load-more {
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    &:hover {
        opacity: .5;
    }
}
</style>

<script>
import articleCard from "./articleCard";
export default {
    components: {
        articleCard,
    },
    props: {
        genre_id: {
            require: true,
        },
        articles: {
            require: true,
        },
        page: {
            default: 1
        }
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        loadArticle() {
            this.isLoading = true;
            setTimeout(() => {this.isLoading = false}, 1000);
            this.$emit("loadArticle", {
                genre_id: this.genre_id,
                page: this.articles.current_page + 1,
            });
        },
    },
    computed: {
        genreArticles() {
            let genreArticles = [];
            if (this.articles && this.articles.data.length) {
                let bag = [];
                for (let i = 0; i < this.articles.data.length; i++) {
                    bag.push(this.articles.data[i]);
                    if ((i + 1) % 3 === 0) {
                        genreArticles.push(bag);
                        bag = [];
                    }
                }
                if (bag) {
                    genreArticles.push(bag);
                }
            }
            return genreArticles;
        },
        hasMorePage() {
            if (!this.articles) return false;
            return this.articles.current_page < this.articles.last_page;
        },
    },
    watch: {
        'articles.current_page'(n, o) {
            this.isLoading = false;
        }
    }
}
</script>